const sidebarMenu = {
    todolist: 'To Do List'
};
export default sidebarMenu;
